import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=6fe96248&"
import script from "./CodeSnippet.vue?vue&type=script&lang=js&"
export * from "./CodeSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports